import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Web config values are safe to expose to the browser — they identify the Firebase
// project, but real access is enforced by Authentication settings, Auth domains,
// and security rules. The values come from .env.local (REACT_APP_FIREBASE_*).
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const missing = Object.entries(firebaseConfig)
  .filter(([, v]) => !v)
  .map(([k]) => k);
if (missing.length > 0) {
  // Surface a clear error in dev rather than letting Firebase fail with a cryptic message.
  console.error(
    `Firebase config missing values: ${missing.join(", ")}. ` +
      "Copy env.example.txt to .env.local and fill in REACT_APP_FIREBASE_* keys."
  );
}

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
